import { Font } from '../../Font';

export function NeutralLogo() {
  return (
    <div className="mt-2" style={{ display: 'flex', flexDirection: 'column' }}>
      <Font
        color="secondary"
        variant="h6"
        style={{
          fontSize: '12px',
          fontWeight: 500,
          top: '-3px',
          marginRight: '10px',
          position: 'relative',
        }}
      >
        Powered by
      </Font>
      <Font color="primary" style={{ height: '35px', overflow: 'hidden' }}>
        <i
          className="icon-nemuru-logo mr1"
          style={{
            verticalAlign: 'sub',
            fontSize: '100px',
            lineHeight: '33px',
          }}
        />
      </Font>
    </div>
  );
}
